import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'
import MonthTabButtonsGroup from 'components/OfferPage/TourV2/Departures/MonthTabs/MonthTabButtonsGroup'
import CruiseDepartureSortDropdown from './CruiseDepartureSortDropdown'

interface Props {
  sort?: string
  yearOptions: Array<number>
  selectedYear?: number
  setSort: (sort: string) => void
  setSelectedYear: (year?: number) => void
}

function CruiseDepartureFilters({
  sort,
  yearOptions,
  selectedYear,
  setSort,
  setSelectedYear,
}: Props) {
  const intl = useIntl()

  return <Group
    direction="vertical"
    tabletDirection="horizontal"
    gap={12}
    horizontalAlign="start"
    tabletHorizontalAlign="space-between"
  >
    {yearOptions.length > 1 && <MonthTabButtonsGroup>
      <Group direction="horizontal" gap={8}>
        <FilterChip
          selected={!selectedYear}
          size="medium"
          onClick={() => setSelectedYear(undefined)}
        >
          {intl.formatMessage({
            id: 'I0-4TdPllLZGuARDcFwd',
            defaultMessage: 'All',
            description: 'Filter chip label to show all departure years in the cruises section',
          })}
        </FilterChip>

        {yearOptions.map((year) => (
          <FilterChip
            key={year}
            selected={selectedYear === year}
            size="medium"
            onClick={() => setSelectedYear(year)}
          >
            {year}
          </FilterChip>
        ))}
      </Group>
    </MonthTabButtonsGroup>}

    <CruiseDepartureSortDropdown sort={sort} onChange={setSort} />
  </Group>
}

export default CruiseDepartureFilters
